import { ActivityDetailQuery } from '../../generated/graphql';
import { useEffect, useRef } from 'react';
import { IS_QUALITYLODGINGS } from '../../constants/analyticsEvents';

const useAnalyticsActivityView = (activity?: ActivityDetailQuery['activity']) => {
    const prev = useRef<ActivityDetailQuery['activity'] | null>(null);
    useEffect(() => {
        if (IS_QUALITYLODGINGS) {
            return;
        }
        window.dataLayer = window.dataLayer ?? [];

        if (activity && activity.id !== prev.current?.id) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    items: [
                        {
                            item_category: 'Activiteit',
                            item_id: activity?.slug,
                            item_name: activity?.name,
                            quantity: 1,
                        },
                    ],
                },
            });
        }
    }, [activity]);
};

export default useAnalyticsActivityView;
